import axios from "axios";
import { has } from "lodash";
import { env } from "../config";

function getCookie(name) {
  return document.cookie
    .split('; ')
    .find(row => row.startsWith(name + '='))
    ?.split('=')[1] || null;
}

if (!env.REACT_APP_API_BASE_URL) {
  throw new Error("REACT_APP_API_BASE_URL is a required environment variable");
}

/**
 * Provide a ready-to-use instance of the XHR api
 * Tokens are now handled via HTTP-only secure cookies
 */
const xhrService = axios.create({
  baseURL: env.REACT_APP_API_BASE_URL,
  withCredentials: true, // Enable sending cookies with requests
});

/** Auth middleware */
xhrService.interceptors.request.use(function setBearerToken(config) {
  // Tokens are now stored in HTTP-only secure cookies
  // No need to manually set Authorization header
  // The browser will automatically send the cookie with each request
  
  const divisionId = JSON.parse(localStorage.getItem("divisionId"));

  const csrfToken = getCookie('csrf_token');

  if (csrfToken) {
    config.headers['X-CSRF-TOKEN'] = csrfToken;
  }

  /** @deprecated */
  if (has(config, "withoutDivision")) {
    console.warn(
      "xhrService configuration option `withoutDivision` is deprecated and has no effect.",
    );
  }

  config.headers.divisionId = divisionId ? `${divisionId}` : "";

  if (config.withoutDivision) {
    delete config.withoutDivision;
  }

  return config;
});

export { xhrService };
export default xhrService;
